import { Action } from 'infra/types'
import { SaleAllocationApiAction } from 'services/Api/StaffLinkApiFolder/type'
import { ICreateSaleAllocation, ICreateSaleAssignment } from 'state/new-summary/list/list.types'
import { CL_VERSIONS } from 'utils/common/common.types'

export const listActions = {
  REFETCH_LIST_AND_POPULATE_STORE: 'listAction/refetchListAndPopulateStore',
  FETCH_ACTIVE_SALE_ALLOCATION: 'listAction/FETCH_ACTIVE_SALE_ALLOCATION',
  CREATE_ACTIVE_SALE_ASSIGNMENT: 'listAction/CREATE_ACTIVE_SALE_ASSIGNMENT',
  CREATE_ACTIVE_SALE_ALLOCATION: 'listAction/CREATE_ACTIVE_SALE_ALLOCATION',
  INIT_CREATE_SALE_ALLOCATION: 'listAction/INIT_CREATE_SALE_ALLOCATION',
  FETCH_SALE_ALLOCATION: 'listAction/FETCH_SALE_ALLOCATION',
  UPDATE_SALE_ALLOCATION: 'listAction/UPDATE_SALE_ALLOCATION'
}

export const refetchListAndPopulateStore = (payload: {
  listId: string
  version?: CL_VERSIONS
}): Action<{ listId: string; version?: CL_VERSIONS }> => {
  return {
    type: listActions.REFETCH_LIST_AND_POPULATE_STORE,
    payload
  }
}

export const fetchActiveSaleAllocationAction = (payload: {
  listId: string
  startTime: number
  endTime: number
}): Action<{ listId: string; startTime: number; endTime: number }> => {
  return {
    type: listActions.FETCH_ACTIVE_SALE_ALLOCATION,
    payload
  }
}

export const createNewSaleAssignmentAction = (payload: {
  listId: string
  startTime: number
  init?: boolean
}): Action<{ listId: string; startTime: number }> => {
  return {
    type: listActions.CREATE_ACTIVE_SALE_ASSIGNMENT,
    payload
  }
}

export const createNewSaleAllocationAction = (payload: {
  saleAllocations: ICreateSaleAllocation['saleAllocations']
  id: string
  listId: string
  init?: boolean
}): Action<ICreateSaleAllocation> => {
  return {
    type: listActions.CREATE_ACTIVE_SALE_ALLOCATION,
    payload
  }
}

export const initSaleAssignmentAction = (payload: {
  id: string
  listId: string
  saleAllocations: ICreateSaleAllocation['saleAllocations']
  startTime: number
  init?: boolean
}): Action<ICreateSaleAllocation & ICreateSaleAssignment> => {
  return {
    type: listActions.INIT_CREATE_SALE_ALLOCATION,
    payload
  }
}

export const fetchSaleAllocationAction = (id: string): Action<string> => {
  return {
    type: listActions.FETCH_SALE_ALLOCATION,
    payload: id
  }
}

export const updateSaleAllocationAction = (payload: {
  saleAllocations: ICreateSaleAllocation['saleAllocations']
  id: string
  action: SaleAllocationApiAction
  listId: string
}): Action<ICreateSaleAllocation & { action: SaleAllocationApiAction; listId: string }> => {
  return {
    type: listActions.UPDATE_SALE_ALLOCATION,
    payload
  }
}
